import {
  getActiveProduct,
  setImageAssets,
  setAddionalAttribues,
  setActiveProduct,
} from './products';

const SET_API = 'SET_API';
const SET_SELECTION = 'SET_SELECTION';

const INIT_PLAYER = 'INIT_PLAYER';
const SHOW_PRESETS = 'SHOW_PRESETS';
const SET_MOVE_STATE = 'SET_MOVE_STATE';

const initialState = {
  initialized: false,
  api: null,
  showPresets: false,
  currentSelection: {},
  moved: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_PLAYER:
      return { ...state, initialized: action.payload };
    case SET_API:
      return { ...state, api: action.payload };
    case SET_SELECTION:
      const newSelection = Object.assign(
        {},
        state.currentSelection,
        action.payload
      );
      return { ...state, currentSelection: newSelection };
    case SHOW_PRESETS:
      return { ...state, showPresets: action.payload };
    default:
      return state;
  }
};

const setApi = api => ({ type: SET_API, payload: api });
export const getApi = state => state.player.api;

export const initPlayer = v => ({ type: INIT_PLAYER, payload: v });
export const initActiveProduct = initConfig => {
  return async (dispatch, getState) => {
    const state = getState();
    const activeProd = getActiveProduct(state);
    if (!activeProd) return null;

    if (initConfig) {
      initPlayer(true);
    }

    let api = getApi(state);
    if (!api) {
      api = window.claraplayer('clara');
      await api.sceneIO.fetchAndUse(
        activeProd.sceneId,
        activeProd.publishedHash
      );
      ['orbit', 'zoom', 'pan', 'home', 'vrSettings', 'fullscreen'].map(
        api.player.hideTool
      );

      api.player.addTool({
        drag: ev => {
          const state = dispatch(getPlayerState());
          const orbitTool = api._store.getState().getIn(['commands', 'all'])
            .orbit;
          const handleFn = orbitTool.tool.drag.call(orbitTool, ev).handle;

          return {
            momentum: true,
            handle: ev => {
              if (handleFn) handleFn(ev);
              if (!state.moved) {
                dispatch({ type: SET_MOVE_STATE, payload: true });
                const config = api.configuration.getConfiguration();
                const render =
                  config['Casters'] === 'Casters' ? 'Casters' : 'Glide';
                api.configuration.setConfiguration({ render });
              }
            },
          };
        },
        click: ev => {
          if (!state.moved) {
            dispatch({ type: SET_MOVE_STATE, payload: true });
            const config = api.configuration.getConfiguration();
            const render =
              config['Casters'] === 'Casters' ? 'Casters' : 'Glide';
            api.configuration.setConfiguration({ render });
          }
        },
      });

      await api.configuration.initConfigurator({
        form: activeProd.form,
        configuration: initConfig ? initConfig : {},
        preset: activeProd.name,
      });
      await api.waitFor('rendered');

      dispatch(setApi(api));
      const assets = getImagesAssets(api);
      dispatch(setImageAssets(activeProd.sceneId, assets));
      // Get addional attributes
      const addtionalAttributes = getAddionalAttributes(api);
      dispatch(setAddionalAttribues(activeProd.sceneId, addtionalAttributes));
    } else {
      console.log('ok');
    }
    const activeConfig = api.configuration.getConfiguration();
    Object.keys(activeConfig).forEach(attr =>
      dispatch(setCurrentSelection(attr, activeConfig[attr]))
    );
  };
};

export const getCurrentSelection = state => state.player.currentSelection;

export const getPlayerState = () => {
  return (dispatch, getState) => {
    return getState().player;
  };
};

export const setCurrentSelection = (key, value) => {
  return (dispatch, getState) => {
    if (value) {
      dispatch(setConfiguration(key, value));
      if (key === 'Casters') {
        //when initial the app, the 'render' will execute after Casters. So render value is still 'initial'
        dispatch(setConfiguration('render', value));
      }
      if (key === 'UpholsteryImage') {
        key = 'Upholstery';
        value = value.name;
        //Override the preset value
      }
      dispatch({
        type: SET_SELECTION,
        payload: { [key]: value },
      });
    }
  };
};

export const setConfiguration = (attr, value) => {
  return async (dispatch, getState) => {
    const state = getState();
    const api = getApi(state);
    let obj = {};
    obj[attr] = value;
    await api.configuration.setConfiguration(obj);
  };
};

export const importImage = (attribute, img) => {
  return async (dispatch, getState) => {
    const state = getState();
    const api = getApi(state);
    const image = await api.assets.importImage(img, {
      keepAspectRatio: true,
    });
    image.name = img.name;
    dispatch(setCurrentSelection(attribute, image));
  };
};

const getImagesAssets = api => {
  const forms = api.configuration.getForms();
  const form = forms && forms[0];
  const imgs = api.configuration
    .getAttributes()
    .map(attribute => {
      let images = [];
      if (form) {
        const field = form.fields.find(
          item => item.attributeId === attribute.id
        );
        if (field && field.displayAs === 'Images' && field.metadata) {
          images = Object.keys(field.metadata).map(k => {
            const imageAsset = api.scene.get({
              name: field.metadata[k],
              evalPlug: 'Image',
            });
            const assetId = imageAsset && imageAsset.asset;
            if (!assetId) return null;
            const url = api.assets.getUrl(assetId);
            return {
              id: k,
              url: url,
              value: k,
            };
          });

          if (attribute.name === 'Upholstery') {
            const order = [
              'Melange',
              'BlazerQuilt',
              'Dark Glitch',
              'Storey Time',
              'Orange Massaud',
            ];

            order.forEach(name => {
              for (let i = 0; i < images.length; i++) {
                if (images[i].id === name) {
                  const current = images.splice(i, 1);
                  images.unshift(current[0]);
                }
              }
            });
          }
          return { [attribute.name]: images };
        }
      }
    })
    .filter(el => !!el);
  return imgs.reduce((acc, el) => Object.assign(acc, el), {});
};

const getAddionalAttributes = api => {
  const filter = {
    Upholstery: true,
    UpholsteryImage: true,
    FrameFinish: true,
    render: true,
    PremiumOptions: true,
  };
  const attributes = api.configuration
    .getAttributes()
    .filter(attr => !filter[attr.name]);
  return attributes.reduce((acc, el) => {
    acc[el.name] = el;
    return acc;
  }, {});
};

export const getUpholstery = state => {
  const api = getApi(state);
  if (!api) return null;
  const attribute = api.configuration.getAttribute('Upholstery');
  return attribute;
};

export const clearSelection = value => {
  return async (dispatch, getState) => {
    if (value) {
      const state = getState();
      const api = getApi(state);
      if (!api) return;
      const activeProd = getActiveProduct(state);
      const fields = api.configuration.getForm(activeProd.form).fields;

      api.configuration.applyPreset(activeProd.name);
    }
    dispatch({ type: SHOW_PRESETS, payload: value });
  };
};

export const changeProduct = value => {
  return async (dispatch, getState) => {
    const state = getState();
    const activeProd = getActiveProduct(state);
    if (!activeProd) return null;
    let api = getApi(state);
    api.configuration.applyPreset(value);
    const activeConfig = api.configuration.getConfiguration();
    Object.keys(activeConfig).forEach(attr =>
      dispatch(setCurrentSelection(attr, activeConfig[attr]))
    );
    dispatch(setActiveProduct(value));
  };
};

export const moveNodeToHome = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const api = getApi(state);
    if (api) api.commands.runCommand('home');
  };
};



// WEBPACK FOOTER //
// ./src/modules/player.js